import React, { Fragment } from 'react';

import states from 'config/states';
import { Button } from 'components/core/Button';
import { Paragraph } from 'components/core/Typography';

import './StatesList.scss';

export function StatesList() {
	return (
		<Fragment>
			<Paragraph>Storage by State</Paragraph>
			<ul className="states-list">
				{Object.keys(states).map((state) => (
					<li
						key={state}
						className="state"
					>
						<Button
							secondary
							className="state-button"
							to={`/self-storage/${states[state].replaceAll(' ', '-').toLowerCase()}/`}
						>
							{state}
						</Button>{' '}
					</li>
				))}
			</ul>
		</Fragment>
	);
}

export default StatesList;
